// extracted by mini-css-extract-plugin
export default {"avatar":"_2rJO0___Avatar-module__avatar"};